import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import { price } from '../Helpers';
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { useSelector, useDispatch } from "react-redux";
import { setData } from "../../redux/actions";
import { Swiper, SwiperSlide } from 'swiper/react';
import { Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/thumbs';

function Product() {
    const { id } = useParams();
    const [product, setProduct] = React.useState(false);
    const [meta, setMeta] = React.useState({ color: "", size: "" });
    const [relatedProduct1, setRelatedProduct1] = React.useState(false);
    const [thumbsSwiper, setThumbsSwiper] = useState(null);
    const [cart, setCart] = useState([]);
    const dispatch = useDispatch();
    let cartRaw = useSelector((state) => state.data?.cart);

    const images = [
        {
            id: 'product-1',
            thumb: '/theme/ashion/img/product/details/thumb-1.jpg',
            main: '/theme/ashion/img/product/details/product-1.jpg',
        },
        {
            id: 'product-2',
            thumb: '/theme/ashion/img/product/details/thumb-2.jpg',
            main: '/theme/ashion/img/product/details/product-2.jpg',
        },
        {
            id: 'product-3',
            thumb: '/theme/ashion/img/product/details/thumb-3.jpg',
            main: '/theme/ashion/img/product/details/product-3.jpg',
        },
        {
            id: 'product-4',
            thumb: '/theme/ashion/img/product/details/thumb-4.jpg',
            main: '/theme/ashion/img/product/details/product-4.jpg',
        },
    ];

    const changeMeta = (e) => {
        setMeta({ ...meta, [e.target.name]: e.target.value });
    };

    const handleAddToCart = (product) => {
        //toast("Product added successfully!");
        toast.success(
            <span>
                Product added successfully! <Link to="/bazaar/cart">View Cart</Link>
            </span>
        );
        setCart((prevCart) => {
            const itemExists = prevCart.find((item) => item._id === product._id && item.color == meta.color && item.size == meta.size);
            if (itemExists) {
                return prevCart.map((item) =>
                    item._id === product._id
                        ? { ...item, quantity: item.quantity + 1 }
                        : item
                );
            } else {
                return [...prevCart, { ...product, quantity: 1, color: meta.color, size: meta.size }];
            }
        });
    };

    const getData = async (productId) => {
        try {
            const response = await axios.post('/product/getAllProducts', { productId });
            const { status, product, relatedProduct } = response.data;
            if (status) {
                setProduct(product[0]);
                setMeta({ ...meta, color: product[0]?.color && product[0]?.color != "" ? product[0]?.color.split(",")[0] : "", size: product[0]?.size && product[0]?.size != "" ? product[0]?.size.split(",")[0] : "" });
                setRelatedProduct1(relatedProduct);
            }
        }
        catch (error) {
            if (error?.response?.data?.message) {
                toast(error.response.data.message);
            }
        }
    };

    useEffect(() => {
        getData(id);
    }, [id]);

    useEffect(() => {
        if (cart.length != 0) {
            localStorage.setItem('cart', JSON.stringify(cart));
            dispatch(setData({ cart: JSON.stringify(cart) }));
        }
    }, [cart]);

    useEffect(() => {
        let parsedCart = [];
        if (typeof cartRaw === "string") {
            try {
                parsedCart = JSON.parse(cartRaw);
            } catch (e) {
                console.error("Invalid JSON in cartRaw:", cartRaw);
            }
        }
        setCart(parsedCart);
    }, [cartRaw]);

    return (
        <>
            <div class="breadcrumb-option">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="breadcrumb__links">
                                <Link to={'/bazaar'}><i class="fa fa-home"></i> Home</Link>
                                <Link to={'/bazaar'}>{product?.categoryId?.categoryName}</Link>
                                <Link to={'/bazaar'}>{product?.subCategoryId?.subCategoryName}</Link>
                                <span>{product.productName}</span>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <section class="product-details spad">
                <div class="container">
                    <div class="row">
                        <div className="col-lg-6">
                            <div className="product__details__pic">
                                {/* Thumbnails */}
                                <div className="product__details__pic__left product__thumb nice-scroll">
                                    <Swiper
                                        direction="vertical"
                                        spaceBetween={10}
                                        slidesPerView="auto"
                                        onSwiper={setThumbsSwiper}
                                        watchSlidesProgress
                                        className="thumbnail-swiper"
                                        freeMode={true} // Allow non-snapped scrolling if needed
                                    >
                                        {product?.images && (product?.images).map((img, idx) => (
                                            <SwiperSlide key={idx} style={{ height: 'auto' }}>
                                                <img src={img} alt={`thumb-${idx}`} />
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>

                                {/* Main Images */}
                                <div className="product__details__slider__content">
                                    <Swiper
                                        spaceBetween={10}
                                        slidesPerView={1}
                                        modules={[Thumbs]}
                                        thumbs={{ swiper: thumbsSwiper }}
                                        className="product__details__pic__slider"
                                    >
                                        {product?.images && (product?.images).map((img, idx) => (
                                            <SwiperSlide key={idx}>
                                                <img src={img} alt={`main-${idx}`} className="product__big__img" />
                                            </SwiperSlide>
                                        ))}
                                    </Swiper>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6">
                            <div class="product__details__text">
                                <h3>{product.productName}</h3>
                                {/* <div class="rating">
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                    <i class="fa fa-star"></i>
                                    <span>( 138 reviews )</span>
                                </div> */}
                                <div class="product__details__price">₹{price(product.price, product.discountInPercent)} <span>₹{product.price}</span></div>
                                <p>{product.description}</p>
                                <div class="product__details__button">
                                    {/* <div class="quantity">
                                        <span>Quantity:</span>
                                        <div class="pro-qty">
                                            <input type="text" value="1" />
                                        </div>
                                    </div> */}
                                    <Link class="cart-btn" onClick={(e) => handleAddToCart(product)}><span class="icon_bag_alt"></span> Add to cart</Link>
                                    {/* <ul>
                                        <li><a href="#"><span class="icon_heart_alt"></span></a></li>
                                        <li><a href="#"><span class="icon_adjust-horiz"></span></a></li>
                                    </ul> */}
                                </div>
                                <div class="product__details__widget">
                                    <ul>
                                        {
                                            product?.color != null && (
                                                <li>
                                                    <span>Available Color:</span>
                                                    <select name="color" onChange={changeMeta}>
                                                        {
                                                            (product.color.split(",")).map(color => (
                                                                <option value={color}>{color}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    {/* <div class="color__checkbox">
                                                        <label for="red">
                                                            <input type="radio" name="color__radio" id="red" checked />
                                                            <span class="checkmark"></span>
                                                        </label>
                                                        <label for="black">
                                                            <input type="radio" name="color__radio" id="black" />
                                                            <span class="checkmark black-bg"></span>
                                                        </label>
                                                        <label for="grey">
                                                            <input type="radio" name="color__radio" id="grey" />
                                                            <span class="checkmark grey-bg"></span>
                                                        </label>
                                                    </div> */}
                                                </li>
                                            )
                                        }
                                        {
                                            product?.size != null && (
                                                <li>
                                                    <span>Available Size:</span>
                                                    <select name="size" onChange={changeMeta}>
                                                        {
                                                            (product.size.split(",")).map(size => (
                                                                <option value={size}>{size}</option>
                                                            ))
                                                        }
                                                    </select>
                                                    {/* <div class="color__checkbox">
                                                        <label for="red">
                                                            <input type="radio" name="color__radio" id="red" checked />
                                                            <span class="checkmark"></span>
                                                        </label>
                                                        <label for="black">
                                                            <input type="radio" name="color__radio" id="black" />
                                                            <span class="checkmark black-bg"></span>
                                                        </label>
                                                        <label for="grey">
                                                            <input type="radio" name="color__radio" id="grey" />
                                                            <span class="checkmark grey-bg"></span>
                                                        </label>
                                                    </div> */}
                                                </li>
                                            )
                                        }
                                    </ul>
                                </div>
                            </div>
                        </div>
                        {/* <div class="col-lg-12">
                            <div class="product__details__tab">
                                <ul class="nav nav-tabs" role="tablist">
                                    <li class="nav-item">
                                        <a class="nav-link active" data-toggle="tab" href="#tabs-1" role="tab">Description</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#tabs-2" role="tab">Specification</a>
                                    </li>
                                    <li class="nav-item">
                                        <a class="nav-link" data-toggle="tab" href="#tabs-3" role="tab">Reviews ( 2 )</a>
                                    </li>
                                </ul>
                                <div class="tab-content">
                                    <div class="tab-pane active" id="tabs-1" role="tabpanel">
                                        <h6>Description</h6>
                                        <p>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut loret fugit, sed
                                            quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt loret.
                                            Neque porro lorem quisquam est, qui dolorem ipsum quia dolor si. Nemo enim ipsam
                                            voluptatem quia voluptas sit aspernatur aut odit aut loret fugit, sed quia ipsu
                                            consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Nulla
                                            consequat massa quis enim.</p>
                                        <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget
                                            dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes,
                                            nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium
                                            quis, sem.</p>
                                    </div>
                                    <div class="tab-pane" id="tabs-2" role="tabpanel">
                                        <h6>Specification</h6>
                                        <p>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut loret fugit, sed
                                            quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt loret.
                                            Neque porro lorem quisquam est, qui dolorem ipsum quia dolor si. Nemo enim ipsam
                                            voluptatem quia voluptas sit aspernatur aut odit aut loret fugit, sed quia ipsu
                                            consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Nulla
                                            consequat massa quis enim.</p>
                                        <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget
                                            dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes,
                                            nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium
                                            quis, sem.</p>
                                    </div>
                                    <div class="tab-pane" id="tabs-3" role="tabpanel">
                                        <h6>Reviews ( 2 )</h6>
                                        <p>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut loret fugit, sed
                                            quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt loret.
                                            Neque porro lorem quisquam est, qui dolorem ipsum quia dolor si. Nemo enim ipsam
                                            voluptatem quia voluptas sit aspernatur aut odit aut loret fugit, sed quia ipsu
                                            consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Nulla
                                            consequat massa quis enim.</p>
                                        <p>Lorem ipsum dolor sit amet, consectetuer adipiscing elit. Aenean commodo ligula eget
                                            dolor. Aenean massa. Cum sociis natoque penatibus et magnis dis parturient montes,
                                            nascetur ridiculus mus. Donec quam felis, ultricies nec, pellentesque eu, pretium
                                            quis, sem.</p>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                    </div>
                    <hr className="hrSingleProduct" />
                    <div class="row">
                        <div class="col-lg-12 text-center">
                            <div class="related__title">
                                <h5>RELATED PRODUCTS</h5>
                            </div>
                        </div>
                        {
                            relatedProduct1 != false && (
                                <OwlCarousel
                                    loop
                                    responsive={{
                                        0: {
                                            items: 1, // Mobile (0px and up)
                                        },
                                        768: {
                                            items: 2, // Tablet (768px and up)
                                        },
                                        1024: {
                                            items: 4, // Desktop (1024px and up)
                                        },
                                    }}
                                >
                                    {
                                        relatedProduct1.map(product1 => (
                                            <div class="col-lg-12 col-md-12 col-sm-12">
                                                <div class="product__item">
                                                    <Link to={'/bazaar/product/' + product1._id}>
                                                        <div class="product__item__pic set-bg" style={{ backgroundImage: `url(${product1?.images?.[0]})` }} data-setbg={product1?.images?.[0]}>
                                                            {/* <div class="label new">New</div> */}
                                                            {/* <ul class="product__hover">
                                                        <li><a href="img/product/related/rp-1.jpg" class="image-popup"><span class="arrow_expand"></span></a></li>
                                                        <li><a href="#"><span class="icon_heart_alt"></span></a></li>
                                                        <li><a href="#"><span class="icon_bag_alt"></span></a></li>
                                                    </ul> */}
                                                        </div>
                                                        <div class="product__item__text">
                                                            <h6>{product1.productName}</h6>
                                                            {/* <div class="rating">
                                                        <i class="fa fa-star"></i>
                                                        <i class="fa fa-star"></i>
                                                        <i class="fa fa-star"></i>
                                                        <i class="fa fa-star"></i>
                                                        <i class="fa fa-star"></i>
                                                    </div> */}
                                                            <div class="product__price"><strike>₹{product1.price}</strike> ₹{price(product1.price, product1.discountInPercent)}</div>
                                                        </div>
                                                    </Link>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </OwlCarousel>
                            )
                        }
                    </div>
                </div>
            </section>
        </>
    );
}

export default Product;
